import type { Paciente } from './api';

/** Une motivo de consulta + HEA para episodio/ingreso (máx. 80 caracteres). */
export function motivoDesdeFicha(p: Pick<Paciente, 'motivoConsulta' | 'historiaEnfermedadActual'>): string {
  return [p.motivoConsulta, p.historiaEnfermedadActual].filter(Boolean).join(' — ').slice(0, 80);
}

/** Separa motivo de episodio en campos de ficha. */
export function fichaDesdeMotivo(motivo: string): { motivoConsulta: string; historiaEnfermedadActual: string } {
  const parts = motivo.split(' — ');
  return {
    motivoConsulta: (parts[0] ?? '').trim(),
    historiaEnfermedadActual: parts.slice(1).join(' — ').trim(),
  };
}

/** Filtra filas por mes YYYY-MM en un campo fecha ISO. */
export function filtrarPorMes<T>(items: T[], mes: string, getFecha: (item: T) => string | null | undefined): T[] {
  if (!mes?.trim()) return items;
  return items.filter(it => {
    const f = getFecha(it);
    return f ? f.startsWith(mes) : false;
  });
}
